// extracted by mini-css-extract-plugin
module.exports = {"tableCellInput":"TableCellInput_tableCellInput__3A3ZK","tableCellInput_text":"TableCellInput_tableCellInput_text__2sJr6"};